<template>
  <div
    v-if="links.length || category.more"
    class="category">
    <collapse-height
      :is-active="shouldToggleCollapse">
      <template #toggler="{ isOpened }">
        <slot
          name="title"
          v-bind="{ isOpened }" />
      </template>

      <template #content>
        <slot
          name="links"
          :links="filteredLinks"
          :more="category.more" />
      </template>
    </collapse-height>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CollapseHeight from 'Components/ui/CollapseHeight/CollapseHeight.vue';

export default {
  name: 'CustomerCategoryLinks',

  components: {
    CollapseHeight,
  },

  props: {
    category: {
      type: Object,
      required: true,
    },

    shouldShowTitle: {
      type: Boolean,
      default: true,
    },

    shouldToggleCollapse: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState(['user']),

    links() {
      if (!this.category._dynamic?.length && this.category.links) {
        return this.category.links;
      }

      const result = this.category.links ? [...this.category.links] : [];

      const dynamicLinks = this.category._dynamic.filter((_dynamic) => {
        const { field, links, validator } = _dynamic;
        const target = field.split('.').reduce((acc, prop) => {
          if (!acc[prop]) {
            return false;
          }

          return acc[prop];
        }, this);

        if (validator(target)) {
          result.push(...links);
          return true;
        }

        return false;
      });

      if (!dynamicLinks.length) {
        result.push(...this.category._defaults.links);
      }

      return result;
    },
    filteredLinks() {
      return this.links.filter((item) => !item.no_index);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
